(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dripp-centered-header"] && !Shopify.designMode) return;
  try {
    

function hulkInitHeaderMenus(){
 document.querySelectorAll('.dl-header').forEach(header=>{
  if(header.dataset.hulkNavigationReady)return;
  header.dataset.hulkNavigationReady='true';
  const menu=header.querySelector('.dl-menu');
  const desktop=window.matchMedia('(min-width:990px)');
  const sync=()=>{menu.open=desktop.matches;header.querySelectorAll('.dl-dropdown[open]').forEach(item=>item.open=false)};
  sync();desktop.addEventListener('change',sync);
  const hover=window.matchMedia('(hover:hover) and (pointer:fine)');
  header.querySelectorAll('.dl-dropdown,.dl-submenu').forEach(item=>{
   let closeTimer;
   const closeSiblings=()=>{Array.from(item.parentElement.children).forEach(other=>{if(other!==item&&other.tagName==='DETAILS')other.open=false})};
   item.addEventListener('toggle',()=>{if(item.open)closeSiblings();else item.querySelectorAll('details[open]').forEach(child=>child.open=false)});
   item.querySelector(':scope > summary').addEventListener('click',event=>{if(event.detail>0&&desktop.matches&&hover.matches){event.preventDefault();closeSiblings();item.open=true}});
   item.addEventListener('pointerenter',()=>{if(desktop.matches&&hover.matches){clearTimeout(closeTimer);closeSiblings();item.open=true}});
   item.addEventListener('pointerleave',()=>{if(desktop.matches&&hover.matches)closeTimer=setTimeout(()=>{if(!item.contains(document.activeElement))item.open=false},160)});
   item.addEventListener('focusout',()=>{setTimeout(()=>{if(!item.contains(document.activeElement)&&!item.matches(':hover'))item.open=false},0)});
  });
  document.addEventListener('click',event=>{
   if(!header.contains(event.target)){header.querySelectorAll('.dl-dropdown[open]').forEach(item=>item.open=false);if(!desktop.matches)menu.open=false}
  });
  header.addEventListener('keydown',event=>{
   if(event.key!=='Escape')return;
   const dropdown=header.querySelector('.dl-submenu[open]')||header.querySelector('.dl-dropdown[open]');
   if(dropdown){dropdown.open=false;dropdown.querySelector('summary').focus()}
   else if(!desktop.matches&&menu.open){menu.open=false;menu.querySelector('summary').focus()}
  });
 });
}
hulkInitHeaderMenus();document.addEventListener('shopify:section:load',hulkInitHeaderMenus);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dripp-outfits"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(event){
 const swatch=event.target.closest('[data-outfit-image]');
 if(swatch){
  const card=swatch.closest('.df-outfit-card');
  const img=card.querySelector('.df-outfit-image');
  img.removeAttribute('srcset');img.src=swatch.dataset.outfitImage;
  if(swatch.dataset.outfitUrl)card.querySelectorAll('a').forEach(a=>a.href=swatch.dataset.outfitUrl);
  card.querySelectorAll('[data-outfit-image]').forEach(b=>b.setAttribute('aria-pressed',String(b===swatch)));
 }
 const more=event.target.closest('.df-outfit-more');
 if(more){more.closest('.df-outfits').querySelectorAll('[data-extra]').forEach(c=>c.hidden=false);more.setAttribute('aria-expanded','true');more.hidden=true;}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dripp-reviews"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',event=>{const button=event.target.closest('[data-review-direction]');if(!button)return;const track=document.getElementById(button.getAttribute('aria-controls'));if(!track||!track.firstElementChild)return;const step=track.firstElementChild.getBoundingClientRect().width+parseFloat(getComputedStyle(track).columnGap);track.scrollBy({left:step*Number(button.dataset.reviewDirection),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dripp-vay-layout"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',event=>{
const hotspot=event.target.closest('[data-look-open]');if(hotspot){document.getElementById(hotspot.dataset.lookOpen)?.showModal();return;}
const close=event.target.closest('[data-look-close]');if(close){close.closest('dialog').close();return;}
if(event.target.matches('dialog.dl-product-dialog')){const r=event.target.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)event.target.close();}
const arrow=event.target.closest('[data-look-scroll]');if(arrow){const track=arrow.closest('.dl-look-shell').querySelector('.dl-look-track');const amount=(track.firstElementChild.getBoundingClientRect().width+14)*Number(arrow.dataset.lookScroll);track.scrollBy({left:amount,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});}
if(event.target.closest('[data-dripp-top]'))window.scrollTo({top:0,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hulk-campaign-bar"] && !Shopify.designMode) return;
  try {
    
function initHulkCampaign(root=document){root.querySelectorAll('[data-hulk-campaign]').forEach(bar=>{
 if(bar.dataset.initialized)return;bar.dataset.initialized='true';
 const pause=bar.querySelector('.hulk-campaign__pause');
 pause?.addEventListener('click',()=>{const paused=pause.getAttribute('aria-pressed')!=='true';pause.setAttribute('aria-pressed',String(paused));pause.querySelector('span').textContent=paused?'▶':'Ⅱ';bar.querySelector('.hulk-campaign__marquee').classList.toggle('is-paused',paused)});
 if(bar.dataset.active!=='true')return;
 if(bar.dataset.paused==='true')return;
 const end=Date.parse(bar.dataset.end);const clock=bar.querySelector('[data-countdown]');
 function tick(){if(!bar.isConnected){clearInterval(timer);return}const left=Math.max(0,Math.floor((end-Date.now())/1000));if(!Number.isFinite(left)||left===0){bar.querySelector('.hulk-campaign__timer')?.remove();bar.querySelectorAll('[data-campaign-title]').forEach(title=>title.textContent=bar.querySelector('[data-campaign-fallback]').textContent);clearInterval(timer);return}const d=Math.floor(left/86400),h=Math.floor(left%86400/3600),m=Math.floor(left%3600/60),s=left%60;clock.textContent=[d,h,m,s].map(x=>String(x).padStart(2,'0')).join(' : ')}
 const timer=setInterval(tick,1000);tick();
})}initHulkCampaign();document.addEventListener('shopify:section:load',e=>initHulkCampaign(e.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hulk-community"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-community-direction]');
  if (!button) return;
  const track = document.getElementById(button.getAttribute('aria-controls'));
  if (!track) return;
  const card = track.querySelector('.hulk-community__card');
  if (!card) return;
  const direction = Number(button.dataset.communityDirection);
  const max = track.scrollWidth - track.clientWidth;
  const step = card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap);
  let target = track.scrollLeft + direction * step;
  if (direction > 0 && track.scrollLeft >= max - 2) target = 0;
  if (direction < 0 && track.scrollLeft <= 2) target = max;
  track.scrollTo({left:target,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hulk-reviews-page"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',event=>{const button=event.target.closest('[data-review-direction]');if(!button)return;const track=document.getElementById(button.getAttribute('aria-controls'));if(!track||!track.firstElementChild)return;const step=track.firstElementChild.getBoundingClientRect().width+parseFloat(getComputedStyle(track).columnGap);track.scrollBy({left:step*Number(button.dataset.reviewDirection),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hulk-welcome-popup"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('hulk-welcome')) {
  customElements.define('hulk-welcome', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.dialog = this.querySelector('dialog');
      this.tab = this.querySelector('[data-open]');
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.querySelector('[data-close]').addEventListener('click', () => this.dialog.close(), options);
      this.tab.addEventListener('click', () => this.open(), options);
      this.dialog.addEventListener('click', event => { if (event.target === this.dialog) { const rect = this.dialog.getBoundingClientRect(); if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close(); } }, options);
      this.dialog.addEventListener('close', () => {
        clearTimeout(this.timer);
        document.documentElement.classList.remove('hw-modal-open');
        this.write('hulk_welcome_dismissed', String(Date.now()));
        this.tab.hidden = this.subscribed;
        if (!this.subscribed) this.tab.focus({ preventScroll: true });
      }, options);
      this.addEventListener('shopify:section:select', () => this.open(), options);
      this.subscribed = this.dataset.subscribed === 'true' || this.read('hulk_welcome_subscribed') === '1';
      const result = this.querySelector('[data-success], [data-errors]');
      const pending = this.read('hulk_welcome_pending');
      const returned = location.hash.includes('HulkWelcomeForm-') || (pending && Date.now() - Number(pending) < 900000);
      if (result && returned) {
        if (this.querySelector('[data-success]')) {
          this.subscribed = true;
          this.write('hulk_welcome_subscribed', '1');
        }
        this.open();
      } else if (new URLSearchParams(location.search).get('welcome') === '1' || this.dataset.designMode === 'true') {
        this.open();
      } else if (!this.subscribed) {
        this.tab.hidden = false;
        const dismissed = Number(this.read('hulk_welcome_dismissed') || 0);
        if (Date.now() - dismissed > 7 * 86400000) this.timer = setTimeout(() => this.autoOpen(), Number(this.dataset.delay) * 1000);
      }
      this.querySelector('form').addEventListener('submit', () => this.write('hulk_welcome_pending', String(Date.now())), options);
    }
    read(key) { try { return localStorage.getItem(key); } catch { return null; } }
    write(key, value) { try { localStorage.setItem(key, value); } catch {} }
    autoOpen() {
      if (!this.isConnected || this.subscribed) return;
      if (document.hidden || [...document.querySelectorAll('dialog[open], [aria-modal="true"]')].some(element => element.getClientRects().length > 0)) {
        this.timer = setTimeout(() => this.autoOpen(), 3000);
        return;
      }
      this.open();
    }
    open() {
      clearTimeout(this.timer);
      if (!this.dialog.open) this.dialog.showModal();
      this.tab.hidden = true;
      document.documentElement.classList.add('hw-modal-open');
      this.querySelector('h2').focus({ preventScroll: true });
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.controller?.abort();
      if (this.dialog?.open) this.dialog.close();
      document.documentElement.classList.remove('hw-modal-open');
      this.ready = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
